/**
 * 表务告警管理模块（src/views/meterAlarmManagement）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / meterManagement.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '删除': 'Delete',
  '详情': 'Details',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '其他': 'Other',
  '导出': 'Export',
  '导出文件': 'Export File',
  '展开': 'Expand',
  '收起': 'Collapse',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '已选择 {count} 项': '{count} items selected',
  '共{total}条': 'Total {total} records',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '折叠': 'Collapse',
  '请输入区域名称': 'Please enter area name',
  '表编号': 'Meter No.',
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '用户手机号': 'Customer Mobile Phone',
  '用户地址': 'Customer Address',
  '表类型': 'Meter Type',
  '表口径': 'Meter Caliber',
  '表安装地址': 'Meter Installation Address',
  '用户余额(元)': 'Customer Balance (CNY)',
  '电池状态': 'Battery Status',
  '阀门状态': 'Valve Status',
  '区域名称': 'Area Name',
  '身份证号': 'ID Number',
  '总计': 'Total',
  '表具总数': 'Total Meters',
  '建档数': 'Filed Count',
  '未知': 'Unknown',
  '正常': 'Normal',
  '欠压': 'Undervoltage',
  '故障': 'Fault',
  '更新人': 'Updated By',
  '文件下载失败': 'File download failed',
  '请设置url.list属性!': 'Please set the url.list property!',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '处理描述': 'Handling Description',
  '请输入处理描述': 'Please enter handling description',

  // ── 未上报查询 / 零流量查询 ──
  '距今': 'From Now',
  '未上报天数': 'Days Not Reported',
  '未用水天数': 'Days Without Water Use',
  '天': 'Day',
  '元': 'CNY',
  '请表类型': 'Select meter type',
  '选择表类型后无法查询出未上报过的表': 'After a meter type is selected, meters that have never reported cannot be queried',
  '未上报查询': 'Not Reported Query',
  '零流量查询': 'Zero Flow Query',
  '最近上报时间': 'Last Report Time',
  '最近上报总用量(m³)': 'Last Reported Total Usage (m³)',
  '最近上报阀门状态': 'Last Valve Status',
  '从未上报': 'Never Reported',
  '用水量(m³)': 'Water Consumption (m³)',

  // ── 抄表异常（告警）处置 ──
  '告警时间': 'Alarm Time',
  '处理状态': 'Handling Status',
  '未处理': 'Unprocessed',
  '处理中': 'Processing',
  '已处理': 'Processed',
  '全部': 'All',
  '处理进度': 'Handling Progress',
  '处理时间': 'Handling Time',
  '处理人': 'Handler',
  '处理': 'Handle',
  '批量处理': 'Batch Handle',
  '处理异常': 'Handle Exception',
  '处理记录': 'Handling Records',
  '故障类型': 'Fault Type',
  '故障描述': 'Fault Description',
  '请选择处理状态': 'Please select handling status',
  '请选择故障类型': 'Please select fault type',
  '请选择用户地址': 'Please select customer address',
  '请选择表口径': 'Please select meter caliber',
  '查询全部故障': 'Query all faults',
  '异常状态': 'Exception Status',
  '最新告警时间': 'Latest Alarm Time',
  '本轮告警次数': 'Alarm Count This Round',
  '总告警次数': 'Total Alarm Count',
  '本轮告警起始时间': 'Current Alarm Round Start Time',
  '本轮告警结束时间': 'Current Alarm Round End Time',
  '数据详情': 'Data Details',
  '历史记录': 'History',
  '安装地址': 'Installation Address',
  '用水地址': 'Water Use Address',
  '请先选择需要批量处理的表号': 'Please select meters to batch process first',
  '选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具': 'Selected records have different handling progress and cannot be processed together. Please re-select meters with the same handling progress',
  '选择批量处理的故障类型不一致不能操作，请重新选择同一故障类型的表具': 'The selected meters have different fault types and cannot be batch handled. Please select meters with the same fault type',

  // ── 故障类型枚举（meterWarnTypeObj / faultObj / plainOptions）──
  '电池欠压': 'Battery Undervoltage',
  '磁干扰': 'Magnetic Interference',
  '有磁干扰': 'Magnetic Interference',
  '存储器故障': 'Memory Fault',
  '存储故障': 'Storage Fault',
  '逆流故障': 'Reverse Flow Fault',
  '阀门故障': 'Valve Fault',
  '阀门损坏': 'Valve Damaged',

  // ── 阀门状态枚举（Mn100FkStatusObj）──
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '阀门开故障': 'Valve Open Fault',
  '阀门关故障': 'Valve Close Fault',
  '无阀': 'No Valve',
  '阀门锈死故障': 'Rusted Valve Fault',
  '无到位信号': 'No In-place Signal',
}
